<template>
  <Form @submit="corporateAccountInfo">
    <div class="content-holder">
      <div class="row-sec">
        <div class="form-holder wow fadeInLeft">
          <ul class="clearfix">
            <li class="full-width f-left">
              <label for="">{{$t("corporation_info.name_of_company")}}</label>
              <Field
                class="form-control"
                name="Company name"
                autofill="off"
                autocomplete="username"
                v-model="form.company_name"
                rules="required"
              />
              <ErrorMessage name="Company name" />
            </li>
            <li class="full-width f-left noColor">
              <label for="">{{$t("corporation_info.country_of_company")}}</label>
              <Field
                class="form-control"
                name="Country"
                v-model="form.company_country"
                rules="required"
                as="select"
                @change="changecountry"
              >
                <option value="" disabled>{{$t("corporation_info.select_company_country")}}</option>
                <option
                  v-for="country in store.countries"
                  :value="country.iso2"
                  :key="country.iso2"
                >
                  {{ country.name }}
                </option>
              </Field>
              <ErrorMessage name="Country" />
            </li>
            <li class="full-width f-left">
              <label for="">{{$t("corporation_info.registration")}}</label>
              <Field
                class="form-control"
                name="Registration"
                autofill="off"
                autocomplete="username"
                v-model="form.registration"
                rules="required"
              />
              <ErrorMessage name="Registration" />
            </li>
          </ul>
          <div class="btn-holder t-center">
            <button type="submit" class="btn btn-yellow popup-link-holder">
              {{$t("corporation_info.submit")}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  mounted() {
    this.store.getCountriesList();
    this.EUContries = Object.keys(this.static_vars.european_countries_list).map(
      (val) => val
    );
  },
  data() {
    return {
      form: {
        company_country: "",
        company_name: "",
        registration: "",
      },
      submitted: false,
      EUContries: [],
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    changecountry(e) {
      this.$refs.phone.choose(e.target.value);
    },
    corporateAccountInfo() {
      let form = JSON.parse(JSON.stringify(this.form));
      this.store
        .corporateAccountInfo(form, true)
        .then(() => {
          if (this.isVerified()) {
            if (!this.hasDeposit()) {
              this.changeStep(4);
            }
          } else {
            this.changeStep(3);
          }
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "corporateAccountInfo",
              platformType: form.platform,
              accountType: form.account_type,
              registrationStep: "1",
            });

            //  live account
            window.dataLayer.push({
              event: "registration",
              ctaType: "LiveAccount",
              ctaPosition: window.location.href, //this should be replaced with an actual page path/cta button type
            });
          } catch (ex) {
            console.log("ex", ex);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
